// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"r5-z","colorTextValue":"s5-z","swatches":"t5-z","collapseLink":"u5-z","isCollapsed":"v5-z","dropdown":"w5-z","disabled":"x5-z"};